import { apiRequest } from './apiClient.js'
import websocketService from './websocketService.js'

async function changeIdentity(path, options) {
  const reconnect = websocketService.shouldReconnect
  websocketService.disconnect()
  try { return await apiRequest(path, options) }
  catch (error) {
    if (reconnect) { websocketService.allowReconnect(); websocketService.connect() }
    throw error
  }
}

export const authOperationsService = {
  logout: (options = {}) => changeIdentity('/api/auth/logout', options),
  switchUser: (options = {}) => changeIdentity('/api/auth/switch-user', options),
  switchBack: (options = {}) => changeIdentity('/api/auth/switch-back', options),
}
